var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"base-modal",class:{
        'base-modal--white': _vm.white,
        'base-modal--with-footer': _vm.$slots.footer,
    }},'div',_vm.$attrs,false),[_c('BaseHeader',{attrs:{"title":_vm.title},on:{"close":function($event){return _vm.$emit('close')}}}),_c('div',{staticClass:"l-padded base-modal__content"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('footer',{staticClass:"l-padded base-modal__actions"},[_vm._t("footer")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }